import { getUserToken } from '@go-client/lib/auth';
import { templateContract } from '../../../../shared/contracts/template';
import { getApiUrlv2, initApiClient } from '@go-client/lib/api';

export const templateClient = initApiClient(templateContract, {
  baseUrl: getApiUrlv2(),
  baseHeaders: {
    'Content-Type': 'application/json',
    authorization: () => `Bearer ${getUserToken()}`,
  },
});
